"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Layer = _interopRequireDefault(require("./Layer"));
var strings = _interopRequireWildcard(require("../../../../../utils/strings"));
var _utils = require("../../../../../utils");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
/* eslint-disable spaced-comment */
/// <reference path="../../../../../../node_modules/maplibre-gl/dist/maplibre-gl.d.ts" />
/* eslint-enable spaced-comment */

class MapboxPolygonLayer extends _Layer.default {
  constructor(layer, polygons) {
    let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let id = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
    super(layer, opts, id);
    this._needsEventSetup = true;
    this._polygons = polygons;
  }
  get strokeLayerId() {
    return `${this.layerId}-stroke`;
  }
  addTo(map) {
    super.addTo(map);
    if (this._strokeLayer) {
      const contains = map.getLayer(this.strokeLayerId) !== undefined;
      if (!contains) {
        map.addLayer(this._strokeLayer, this.layerId);
      }
    }
    if (this._needsEventSetup) {
      map.on('click', this.layerId, e => {
        this.trigger('click', {
          data: this.data,
          shape: this.renderable
        });
      });
      map.on('mouseenter', this.layerId, e => {
        this.trigger('mouseover', {
          data: this.data,
          shape: this.renderable
        });
      });
      map.on('mouseleave', this.layerId, e => {
        this.trigger('mouseout', {
          data: this.data,
          shape: this.renderable
        });
      });
      this._needsEventSetup = false;
    }
  }
  remove() {
    if (!this.map) return;
    if (this._strokeLayer) {
      const contains = this.map.getLayer(this.strokeLayerId) !== undefined;
      if (contains) {
        this.map.removeLayer(this.strokeLayerId);
      }
    }
    super.remove();
  }
  invalidate() {
    const isMulti = this._polygons.length > 1;
    const polygons = (this._polygons || []).map(polygon => {
      const outer = polygon.outer.map(c => [c.lon, c.lat]);
      const inner = polygon.inner ? polygon.inner.map(p => p.map(c => [c.lon, c.lat])) : [];
      return [outer, ...inner];
    });
    this.source = {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: [{
          type: 'Feature',
          geometry: {
            type: isMulti ? 'MultiPolygon' : 'Polygon',
            coordinates: isMulti ? polygons : polygons[0] || []
          }
        }]
      }
    };
    this.createRenderable();
    if (this.map) {
      const map = this.map;
      this.remove();
      this.addTo(map);
    }
  }
  createRenderable() {
    const style = this.opts;
    const convertedStyle = {
      fill: {},
      stroke: {}
    };
    // format the line/fill styles as required for the Mapbox paint style spec
    ['fill', 'line'].forEach(type => {
      const dest = type === 'line' ? 'stroke' : 'fill';
      Object.keys(style).filter(key => new RegExp(`^${type}-`).test(key)).forEach(prop => {
        const k = strings.hyphenate(prop);
        if ((0, _utils.isset)(style[prop])) {
          convertedStyle[dest][k] = style[prop];
        }
      });
    });
    // need to create a separate layer for the stoke style since Mapbox
    // doesn't allow you to set the apply stroke styling to a fill layer
    if (Object.keys(convertedStyle.stroke).length > 0) {
      this._strokeLayer = {
        id: this.strokeLayerId,
        type: 'line',
        source: this.sourceId,
        layout: {},
        paint: convertedStyle.stroke
      };
    }
    return {
      id: this.layerId,
      type: 'fill',
      source: this.sourceId,
      layout: {},
      paint: convertedStyle.fill
    };
  }
}
var _default = exports.default = MapboxPolygonLayer;
module.exports = exports.default;